import { isEqual } from 'lodash-es'
import { createReducer, on } from '@ngrx/store'
import { createEntityAdapter, EntityState } from '@ngrx/entity'

import { ElasticSearchFilters } from 'src/services/elastic-search'
import * as CreditNoteViewActions from './credit-notes-view.actions'
import { prepareCreditNotesPayload } from './credit-notes-view-filters.utils'
import { CreditNoteRow } from 'src/services/data/credit-note-elastic.service'

export const creditNoteViewsFeatureKey = 'creditNoteViews'

export interface CreditNoteViewsState extends EntityState<CreditNoteRow> {
  filters: Dictionary<ElasticSearchFilters>
  prevQuery: Dictionary<any>
  // credit note ids lists grouped by table key
  tables: Dictionary<string[]>
  // total credit notes lists grouped by table key
  totals: Dictionary<Dictionary<any>>
}

const selectId = row => {
  return row.credit_note_id
}

export const adapter = createEntityAdapter<CreditNoteRow>({ selectId })

const initialState: CreditNoteViewsState = adapter.getInitialState({
  tables: {},
  totals: {},
  filters: {},
  prevQuery: {},
})

export const creditNoteViewReducer = createReducer(
  initialState,
  on(CreditNoteViewActions.loadCreditNoteViews,
    (state, action) => {
      const key = action.tableKey
      const query = prepareCreditNotesPayload(action.filters, action.page)
      const prev = state.prevQuery[key] || {}

      let { tables, prevQuery } = state
      if (!isEqual(query.query, prev.query)) {
        tables = { ...tables, [key]: undefined } // drop table
        prevQuery = { ...prevQuery, [key]: query } // save query
  
      } else if (!isEqual(query.sort, prev.sort)) {
        const table = [...tables[key] || []]
        tables = { ...tables, [key]: table.fill(undefined) } // clear table
        prevQuery = { ...prevQuery, [key]: query } // save query
      }
      return { ...state, tables, totals: {}, prevQuery }
    }),
  on(CreditNoteViewActions.loadCreditNoteViewsSuccess,
    (state, action) => {
      const key = action.tableKey
      const { total, totals: totals_, creditNoteViews, payload: { skip } } = action
      const creditNoteIds = creditNoteViews.map(selectId)

      let table = Array.from<string>({ length: total }).fill(undefined)
      table.splice(skip, creditNoteIds.length, ...creditNoteIds) // NOTE: creditNoteIds.length or limit?
      const tables = { ...state.tables, [key]: table }
      const totals = { ...state.totals, [key]: totals_ }

      state = adapter.upsertMany(action.creditNoteViews, state)
      return { ...state, tables, totals }
    }),
  on(CreditNoteViewActions.loadCreditNoteFiltersSuccess,
    (state, action) => {
      const key = action.tableKey
      const filters = { ...state.filters, [key]: action.result }
      return { ...state, filters }
    }),
)
